/**
 * Header primary navigation (mobile interaction).
 *
 * Desktop keeps CSS hover dropdowns.
 * Mobile uses tap-to-open behavior and shows only one active submenu at a time.
 */
(function () {
  const nav = document.querySelector(".main-header__primary-nav");
  if (!(nav instanceof HTMLElement)) return;

  const menu = nav.querySelector("#header-primary-menu");
  if (!(menu instanceof HTMLElement)) return;

  const mq = window.matchMedia("(max-width: 782px)");

  const getRootLis = () => Array.from(menu.children).filter((el) => el instanceof HTMLLIElement);
  const getDirectLink = (li) => Array.from(li.children).find((el) => el instanceof HTMLAnchorElement) || null;
  const getDirectSubMenu = (li) =>
    Array.from(li.children).find((el) => el instanceof HTMLElement && el.classList.contains("sub-menu")) || null;

  let activeRoot = null;

  const setOpen = (open) => {
    nav.dataset.open = open ? "true" : "false";
    if (!open) {
      getRootLis().forEach((li) => {
        li.removeAttribute("data-active");
        const sub = getDirectSubMenu(li);
        if (sub) sub.setAttribute("data-open", "false");
      });
      // Reset any nested expanded states.
      menu.querySelectorAll("[data-expanded]").forEach((el) => el.removeAttribute("data-expanded"));
      menu.querySelectorAll("[data-tvk-armed]").forEach((el) => el.removeAttribute("data-tvk-armed"));
      menu.querySelectorAll(".sub-menu[data-open]").forEach((el) => el.setAttribute("data-open", "false"));
      activeRoot = null;
    }
  };

  const setActiveRoot = (li) => {
    getRootLis().forEach((rootLi) => {
      const isActive = rootLi === li;
      rootLi.setAttribute("data-active", isActive ? "true" : "false");
      const sub = getDirectSubMenu(rootLi);
      if (sub) sub.setAttribute("data-open", isActive ? "true" : "false");
      const link = getDirectLink(rootLi);
      if (link) link.removeAttribute("data-tvk-armed");
    });
    activeRoot = li;
  };

  // Init closed.
  setOpen(false);

  // Mobile-only click handling (event delegation).
  menu.addEventListener("click", (e) => {
    if (!mq.matches) return; // Desktop: CSS hover/focus.
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;

    const link = target.closest("a");
    if (!(link instanceof HTMLAnchorElement)) return;
    if (!menu.contains(link)) return;

    const li = link.parentElement;
    if (!(li instanceof HTMLLIElement)) return;

    const sub = getDirectSubMenu(li);
    const isRoot = li.parentElement === menu;
    const isOpen = nav.dataset.open === "true";
    const armed = link.getAttribute("data-tvk-armed") === "true";

    // If this item has no children, allow normal navigation.
    if (!(sub instanceof HTMLElement)) return;

    // Root items open the panel and switch the active root.
    if (isRoot) {
      const isSame = activeRoot === li;
      if (!isOpen || !isSame) {
        e.preventDefault();
        setOpen(true);
        setActiveRoot(li);
        link.setAttribute("data-tvk-armed", "true");
        return;
      }

      // Second tap on same root: navigate.
      if (!armed) {
        e.preventDefault();
        link.setAttribute("data-tvk-armed", "true");
      }
      return;
    }

    // Nested items (levels 2-4): accordion-style toggle inside the open panel.
    if (!isOpen) {
      e.preventDefault();
      setOpen(true);
    }

    const currentlyOpen = sub.getAttribute("data-open") === "true";

    // Close sibling submenus at the same level.
    const parentUl = li.parentElement;
    if (parentUl instanceof HTMLElement) {
      Array.from(parentUl.children).forEach((sibling) => {
        if (!(sibling instanceof HTMLLIElement) || sibling === li) return;
        sibling.removeAttribute("data-expanded");
        const sibSub = getDirectSubMenu(sibling);
        if (sibSub) sibSub.setAttribute("data-open", "false");
        const sibLink = getDirectLink(sibling);
        if (sibLink) sibLink.removeAttribute("data-tvk-armed");
      });
    }

    // First tap: toggle open and prevent navigation.
    if (!currentlyOpen) {
      e.preventDefault();
      sub.setAttribute("data-open", "true");
      li.setAttribute("data-expanded", "true");
      link.setAttribute("data-tvk-armed", "true");
      return;
    }

    // If open, allow navigation on second tap (armed).
    if (!armed) {
      e.preventDefault();
      link.setAttribute("data-tvk-armed", "true");
    }
  });

  // Close when tapping outside the nav (mobile only).
  document.addEventListener("click", (e) => {
    if (!mq.matches) return;
    if (nav.dataset.open !== "true") return;
    if (e.target instanceof Node && nav.contains(e.target)) return;
    setOpen(false);
  });

  // Close on resize to desktop to avoid stale state.
  window.addEventListener("resize", () => {
    if (!mq.matches) setOpen(false);
  });
})();

